import React from 'react'

const VisCircle = ({
  color   = '',
  total   = 0,
  won     = 0
}) => {

  const percent           = Math.round((parseInt(won)/parseInt(total)) * 100)
  const rotationAngle     = Math.round(360 * (percent / 100))
  const backgroundColor   = '#e5e5e5'
  
  return (
    <div className="data-chart" data-chart={"1"} style={{ width:'135px', height:'135px' }}>
      <div className="outer-circle">
        <div data-wedge-id="a" className="wedge-container" style={ { transform: 'rotate(0deg)', WebkitTransform: 'rotate(0deg)', clip: 'auto', msTransform: 'rotate(0deg)' } }>
          <div className="wedge" style={ { msTransform: 'rotate(' + rotationAngle + 'deg)', WebkitTransform: 'rotate(' + rotationAngle + 'deg)', transform: 'rotate(' + rotationAngle + 'deg)', clip: 'rect(0px 73px 150px 0px)', backgroundColor: rotationAngle < 180 ? backgroundColor : color } }></div>
          <div className="wedge-extension" style={ { opacity: 1, msTransform: 'rotate(180deg)', WebkitTransform: 'rotate(180deg)', transform: 'rotate(180deg)', clip: 'rect(0px 75px 150px 0px)', backgroundColor: rotationAngle < 180 ? backgroundColor : color } }></div>
        </div>
        <div data-wedge-id="b" className="wedge-container" style={ { msTransform: 'rotate(' + rotationAngle + 'deg)', WebkitTransform: 'rotate(' + rotationAngle + 'deg)', transform: 'rotate(' + rotationAngle + 'deg)', clip: 'rect(0px 150px 150px 75px)' } }>
          <div className="wedge" style={ { msTransform: 'rotate(' + (360 - rotationAngle) + 'deg)', WebkitTransform: 'rotate(' + (360 - rotationAngle) + 'deg)', transform: 'rotate(' + (360 - rotationAngle) + 'deg)', clip: 'rect(0px 73px 150px 0px)', backgroundColor: rotationAngle < 180 ? color : backgroundColor } }></div>
          <div className="wedge-extension" style={ { opacity: 0 } }></div>
        </div>
      </div>
      
      <div className="inner-circle">
        <span className="team-logo"></span>
        <span className="team-name"></span>
        <span className="home-team">{won+'/'+total}</span>
        <span className="away-team">{percent + '%'}</span>
      </div>
    </div>
  )

}

export default VisCircle



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/components/statistics/VisCircle.jsx